import { TileGridCard } from '@hevoio/hevo-ui-toolkit';
import type { TileGridCardProps, TileGridCardBadgeConfig } from '@hevoio/hevo-ui-toolkit';
import { EntityTileProps } from '../../interfaces/tile';

interface EntityTileComponentProps extends Pick<TileGridCardProps, 'subTextMaxLines'> {
  tile: EntityTileProps;
}

function EntityTile({ tile, subTextMaxLines = 1 }: EntityTileComponentProps) {
  const { badgeMetaData = {}, faded, selected } = tile.metaData;

  const badgeConfig: TileGridCardBadgeConfig = {
    new: { visible: !!badgeMetaData.showNewBadge },
    inProgress: { visible: !!badgeMetaData.showInProgressBadge },
    failed: { visible: !!badgeMetaData.showFailedBadge },
    draft: { visible: !!badgeMetaData.showDraftBadge },
    edge: { visible: !!badgeMetaData.showEdgeBadge },
    beta: { visible: !!badgeMetaData.showBetaBadge },
    free: { visible: !!badgeMetaData.showFreeBadge },
    earlyAccess: { visible: !!badgeMetaData.showEarlyAccessBadge },
    ongoingTrial: { visible: !!badgeMetaData.showOngoingTrialBadge },
    paid: { visible: !!badgeMetaData.showPaidBadge },
    privateBeta: { visible: !!badgeMetaData.showPrivateBetaBadge },
    upcoming: { visible: !!badgeMetaData.showUpcomingBadge },
    disabled: { visible: !!tile.disabled && !tile.data.error },
    deprecating: {
      visible: !!badgeMetaData.showDeprecatingBadge,
      showTooltip: !!badgeMetaData.deprecatingBadgeTooltip,
      tooltipProps: badgeMetaData.deprecatingBadgeTooltip
        ? { title: badgeMetaData.deprecatingBadgeTooltip }
        : undefined
    }
  };

  return (
    <TileGridCard
      disabled={tile.disabled}
      error={tile.data.error}
      faded={faded}
      selected={selected}
      logoURL={tile.thumbnail}
      darkModeLogoURL={tile.darkModeThumbnail || ''}
      title={tile.title}
      titleDataId={`${tile.id}-title`}
      subtitle={tile.subtitle}
      subtitleDataId={`${tile.id}-subtitle`}
      subTextMaxLines={subTextMaxLines}
      badgeConfig={badgeConfig}
    />
  );
}

export default EntityTile;